<template>
  <a-menu
    v-model="showMenu"
    transition="slide-y-transition"
    bottom
    close-on-content-click
    close-on-click
  >
    <template v-slot:activator="{ on: menu, attrs }">
      <v-tooltip bottom>
        <template v-slot:activator="{ on: tooltip }">
          <a-btn
            class="purple"
            color="primary"
            dark
            v-bind="attrs"
            v-on="{ ...tooltip, ...menu }"
          >
            {{ $t("template.lblSelectPlaceholder") }}
          </a-btn>
        </template>
        <span v-html="$t('template.tipSelectCopyBtn')"></span>
      </v-tooltip>
    </template>
    <v-list dense>
      <v-list-item v-for="(item, i) in templatePlaceHolderItems" :key="i" link>
        <v-list-item-title
          >{{ $t(`placeholders.${item.key}`) }}
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                small
                v-bind="attrs"
                v-on="on"
                @click.stop="copyToClipboard(item.value)"
                class="ml-4"
              >
                <v-icon small>mdi-content-copy</v-icon>
              </v-btn>
            </template>
            <span>{{ $t("poll.tipCopy") }}</span>
          </v-tooltip></v-list-item-title
        >
      </v-list-item>
    </v-list>
  </a-menu>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "Placeholders",
  data() {
    return {
      showMenu: false,
    };
  },
  props: {
    type: {
      type: String,
      default: "meeting",
    },
    templateTypeId: {
      type: String,
      default: "",
    },
  },
  computed: {
    ...mapGetters({
      masterSettingConfig: "tenant/masterSettingConfig",
    }),
    templatePlaceHolderItems() {
      const config = this.masterSettingConfig(
        "email_template_dynamic_variables"
      );
      const allPlaceholders = config?.email_template_dynamic_variables || [];

      let placeholders = allPlaceholders.filter(
        (p) => p.type === "general" || p.type === this.type
      );

      if (this.templateTypeId !== "ConvocationMail") {
        placeholders = placeholders.filter(
          (p) => p.key !== "lblMeetingDescription"
        );
      }

      if (this.templateTypeId === "MeetingCreate") {
        placeholders = placeholders.filter((p) => p.key !== "lblTopicDetails");
      }

      return placeholders;
    },
  },
  methods: {
    copyToClipboard,
  },
};

function copyToClipboard(text) {
  navigator.clipboard.writeText(text);
  this.showMenu = false;
}
</script>

<style>
</style>